import styles from "./AccountingGroupForm.module.scss"

import type { UseFormRegisterReturn } from "react-hook-form"

type Props = {
	register: UseFormRegisterReturn
	bankName: string | null
	error?: string
}

const BankCodeInput = ({ register, bankName, error }: Props) => {
	return (
		<div className={styles.field}>
			<label className={styles.label}>銀行コード</label>
			<div className={styles.code_input_row}>
				<input
					type="text"
					maxLength={4}
					placeholder="0001"
					className={`${styles.input} ${styles.code_input} ${error ? styles.input_error : ""}`}
					{...register}
				/>
				<span className={styles.lookup_name}>
					{bankName === null ? "" : bankName || "該当なし"}
				</span>
			</div>
			{error && <span className={styles.error_message}>{error}</span>}
		</div>
	)
}

export default BankCodeInput
